import { render, staticRenderFns } from "./MobileNavigationView.vue?vue&type=template&id=652a2d8b&"
import script from "./MobileNavigationView.vue?vue&type=script&lang=js&"
export * from "./MobileNavigationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports